import { API_BASE_URL } from "../constants";
import { ApiManager } from "../utils/ApiManager/ApiManager";

export const mskApi = new ApiManager(API_BASE_URL);
